import { SET_FORMULA, SET_FORMULAS } from "../../constants/manufactureFormulaConstants";

export const setManufactureFormula = (formula) => {
  return {
    type: SET_FORMULA,
    formula,
  };
};

export const setManufactureFormulas = (formulas) => {
  return {
    type: SET_FORMULAS,
    formulas,
  };
};
